<div class="flex-row flex">
    <mat-icon
        class="cb-help-cursor"
        [ngClass]="actvityStatus.value.class"
        [svgIcon]="actvityStatus.value.icon"
        [matTooltip]="actvityStatus.value.text"
    ></mat-icon>
    @if (poDownloadStatus.value.visible) {
        <mat-icon
            class="cb-help-cursor"
            [ngClass]="poDownloadStatus.value.class"
            [svgIcon]="poDownloadStatus.value.icon"
            [matTooltip]="poDownloadStatus.value.text"
        ></mat-icon>
    }
    @if (complianceStatus.value.visible) {
        <mat-icon
            class="cb-help-cursor"
            [ngClass]="complianceStatus.value.class"
            [svgIcon]="complianceStatus.value.icon"
            [matTooltip]="complianceStatus.value.text"
        ></mat-icon>
    }
    @if (buildProgrammeActivity?.hasUnallocatedQuantity) {
        <mat-icon
            class="cb-help-cursor"
            svgIcon="gauge-full"
            class="cb-grey"
            [matTooltip]="'Has Unallocated Quantity'"
        ></mat-icon>
    }
    @if (buildProgrammeActivity?.hasHorizontalPredecessor) {
        <mat-icon
            class="cb-help-cursor"
            svgIcon="ray-start-arrow"
            class="cb-primary"
            [matTooltip]="'Activity has Horizontal Predecessor'"
        ></mat-icon>
    }
    @if (pausedStatus.value.visible) {
        <mat-icon
            class="cb-help-cursor"
            [svgIcon]="pausedStatus.value.icon"
            [ngClass]="pausedStatus.value.class"
            [matTooltip]="pausedStatus.value.text"
        ></mat-icon>
    }
    @if (buildProgrammeActivity?.isTransformedToManualOrder) {
        <mat-icon
            class="cb-help-cursor"
            svgIcon="transfer"
            class="cb-grey"
            matTooltip="Transformed to Manual Order"
        ></mat-icon>
    }
    @if (buildProgrammeActivity?.splitFromBuildActivityId > 0) {
        <mat-icon
            class="cb-help-cursor"
            svgIcon="call-split"
            class="cb-grey"
            matTooltip="Split Activity"
        ></mat-icon>
    }
    @if (blockLevelActivityStatus.value.visible) {
        <mat-icon
            class="cb-help-cursor"
            [svgIcon]="blockLevelActivityStatus.value.icon"
            [ngClass]="blockLevelActivityStatus.value.class"
            [matTooltip]="blockLevelActivityStatus.value.text"
        ></mat-icon>
    }
    @if (needsVariationAssociatedStatus.value.visible) {
        <mat-icon
            class="cb-help-cursor"
            [svgIcon]="needsVariationAssociatedStatus.value.icon"
            [ngClass]="needsVariationAssociatedStatus.value.class"
            [matTooltip]="needsVariationAssociatedStatus.value.text"
        >
        </mat-icon>
    }
    @if (hasUnknownRateStatus.value.visible) {
        <mat-icon
            class="cb-help-cursor"
            [svgIcon]="hasUnknownRateStatus.value.icon"
            [ngClass]="hasUnknownRateStatus.value.class"
            [matTooltip]="hasUnknownRateStatus.value.text"
        ></mat-icon>
    }
</div>
